<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jTWKjZ/tc-custom/9780830869923.jpg?1692013527436?1696374745218" alt="This image is the cover for the book Hearing God"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hearing God
      </h1>
      <p class="bookDescription body article font2">
        <p><em>and</em><em>In Search of Guidance,</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dallas Willard
      </h2>
      
      <p class="authorDescription body article"><p><em>The Divine Conspiracy</em><em>Christianity Today?s</em><em>The Spirit of the Disciplines, Hearing God, Renovation of the Heart</em><em>Christianity Today</em></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?766a40e0